import { Text, Button, useTheme } from '@simplywallst/ui-core';

import ArticleOutline from '@simplywallst/ui-core/icons/ArticleOutline';
import MarketInsightsOutline from '@simplywallst/ui-core/icons/MarketInsightsOutline';
import PortfolioOutline from '@simplywallst/ui-core/icons/PortfolioOutline';
import DiscoverOutline from '@simplywallst/ui-core/icons/DiscoverOutline';
import CrossSolid from '@simplywallst/ui-core/icons/CrossSolid';

import {
  OnboardingWrapper,
  MobileIconWrapper,
  Header,
  MobileGradientLine,
  MobileShortGradientLine,
  MobileGradientBackground,
  MobileTreeWrapper,
  MobileRowWrapper,
  MobileLetGoButton,
  MobileModalBoard,
  ButtonWrapper,
  CloseButtonWrapper,
} from './styled';

type Props = {
  completeOnboarding: () => void;
};

const BackgroundTree = () => {
  return (
    <MobileTreeWrapper>
      <MobileGradientBackground />
      <MobileGradientLine />
      <MobileShortGradientLine idx={0} />
      <MobileShortGradientLine idx={1} />
      <MobileShortGradientLine idx={2} />
      <MobileShortGradientLine idx={3} />
    </MobileTreeWrapper>
  );
};

export const MobileOnboardingContent = ({ completeOnboarding }: Props) => {
  const theme = useTheme();
  return (
    <OnboardingWrapper
      data-cy-id="onboarding-modal-wrapper"
      alignItems="center"
      justifyContent="center"
    >
      <MobileModalBoard>
        <CloseButtonWrapper>
          <Button
            type="button"
            styleType="passive"
            onClick={() => completeOnboarding()}
          >
            <CrossSolid />
          </Button>
        </CloseButtonWrapper>
        <Header data-cy-id="onboarding-header">
          <Text as="span" typography="xLargeStrong" textAlign="center">
            Level up{' '}
          </Text>
          <br />
          <Text as="span" typography="xLarge" textAlign="center">
            your whole investing <br />
            process
          </Text>
        </Header>
        <BackgroundTree />
        <MobileRowWrapper
          templateColumns="1fr 48px 1fr"
          templateRows="repeat(4, 76px)"
        >
          <Text typography="xSmall" color="brand02" textAlign="left">
            Understand any <br /> business quickly
          </Text>
          <MobileIconWrapper>
            <ArticleOutline
              fill={theme.color.brand03}
              width={theme.x3spacePx}
              height={theme.x3spacePx}
            />
          </MobileIconWrapper>
          <Text typography="xSmallStrong" textAlign="left">
            Visual Unbiased <br /> Stock Reports
          </Text>

          <Text typography="xSmall" color="brand02" textAlign="left">
            Discover & watch <br /> hidden gems
          </Text>
          <MobileIconWrapper>
            <DiscoverOutline
              fill={theme.color.brand03}
              width={theme.x3spacePx}
              height={theme.x3spacePx}
            />
          </MobileIconWrapper>
          <Text typography="xSmallStrong" textAlign="left">
            Investing <br />
            Ideas
          </Text>

          <Text typography="xSmall" color="brand02" textAlign="left">
            Nurture & protect
            <br /> your portfolio
          </Text>
          <MobileIconWrapper>
            <PortfolioOutline
              fill={theme.color.brand03}
              width={theme.x3spacePx}
              height={theme.x3spacePx}
            />
          </MobileIconWrapper>
          <Text typography="xSmallStrong" textAlign="left">
            Portfolio Tracker
            <br /> & Analysis
          </Text>

          <Text typography="xSmall" color="brand02" textAlign="left">
            Stay informed
            <br /> without the noise
          </Text>
          <MobileIconWrapper>
            <MarketInsightsOutline
              fill={theme.color.brand03}
              width={theme.x3spacePx}
              height={theme.x3spacePx}
            />
          </MobileIconWrapper>
          <Text typography="xSmallStrong" textAlign="left">
            Intelligent <br />
            Updates
          </Text>
        </MobileRowWrapper>

        <ButtonWrapper>
          <MobileLetGoButton
            data-cy-id="onboarding-letsgo-button"
            styleType="louder"
            onClick={() => completeOnboarding()}
          >
            Let&apos;s go!
          </MobileLetGoButton>
        </ButtonWrapper>
      </MobileModalBoard>
    </OnboardingWrapper>
  );
};
